"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHEMKIT_DASHBOARD_EVENT_CLOSED = exports.CHEMKIT_DASHBOARD_EVENT_OPEN_FAILED = exports.CHEMKIT_DASHBOARD_EVENT_OPENED = exports.CHEMKIT_DASHBOARD_EVENT_OPEN_READY = exports.CHEMKIT_DASHBOARD_EVENT_OPEN_CLICKED = exports.CHEMKIT_DASHBOARD_EVENT_AGGREGATE = void 0;
exports.CHEMKIT_DASHBOARD_EVENT_AGGREGATE = "chemkit.dashboard";
exports.CHEMKIT_DASHBOARD_EVENT_OPEN_CLICKED = "chemkit.dashboard.open_clicked";
exports.CHEMKIT_DASHBOARD_EVENT_OPEN_READY = "chemkit.dashboard.open_ready";
exports.CHEMKIT_DASHBOARD_EVENT_OPENED = "chemkit.dashboard.opened";
exports.CHEMKIT_DASHBOARD_EVENT_OPEN_FAILED = "chemkit.dashboard.open_failed";
exports.CHEMKIT_DASHBOARD_EVENT_CLOSED = "chemkit.dashboard.closed";
